export default __webpack_public_path__ + "static/media/courthouse1.15eb24b1.png";